import { IoMdClose } from 'react-icons/io'
import { Badge, SelectedFiltersContainer } from './styles'
import {
  CheckboxTexts,
  MyQuestionsLabels,
  SelectLabels,
  TCheckboxName,
  TCheckboxesData,
  TMyQuestions,
  TSelectName,
  TSelected,
} from './data'
import { IOption } from '../../../../components/SearchMultiselect'
import { useMemo } from 'react'

interface IProps {
  textInput: string
  selected: TSelected
  checkboxes: TCheckboxesData
  myQuestions: TMyQuestions

  onSelectRemove: (selectName: TSelectName, option: IOption) => () => void
  onCheckboxRemove: (checkboxName: TCheckboxName) => () => void
  onTextInputRemove: () => void
  onMyQuestionsRemove: (key: keyof TMyQuestions) => () => void
}

const SelectedFilters = (props: IProps) => {
  const totalSelects = useMemo(
    () => Object.values(props.selected).reduce((acc, options) => acc + options.length, 0),
    [props.selected]
  )

  const totalCheckboxes = useMemo(
    () => Object.values(props.checkboxes).reduce((acc, isMarked) => (isMarked ? acc + 1 : acc), 0),
    [props.checkboxes]
  )

  const totalMyQuestions = useMemo(
    () => Object.values(props.myQuestions).reduce((acc, value) => (value ? acc + 1 : acc), 0),
    [props.myQuestions]
  )

  const totalFilters = totalSelects + totalCheckboxes + totalMyQuestions + (props.textInput ? 1 : 0)

  const renderSelectBadges = () => {
    const entries = Object.entries(props.selected) as [TSelectName, IOption[]][]

    const badges = entries.map((entry) => {
      const [selectName, optionsArray] = entry
      const label = SelectLabels[selectName]

      return optionsArray.map((option) => (
        <Badge key={option.label + option.value}>
          <b>{label}:</b> {option.label}{' '}
          <button className="remove" onClick={props.onSelectRemove(selectName, option)}>
            <IoMdClose className="icon" size={24} />
          </button>
        </Badge>
      ))
    })

    return badges
  }

  const renderCheckboxBadges = () => {
    const entries = Object.entries(props.checkboxes) as [TCheckboxName, boolean][]

    const badges = entries.map((entry) => {
      const [checkboxName, isMarked] = entry

      if (isMarked === false) return null

      const { label, value } = CheckboxTexts[checkboxName]

      return (
        <Badge key={checkboxName}>
          <b>{label}:</b> {value}{' '}
          <button className="remove" onClick={props.onCheckboxRemove(checkboxName)}>
            <IoMdClose className="icon" size={24} />
          </button>
        </Badge>
      )
    })

    return badges
  }

  const renderMyQuestionsBadges = () => {
    const entries = Object.entries(props.myQuestions) as [keyof TMyQuestions, boolean][]

    const badges = entries.map((entry) => {
      const [key, value] = entry

      if (value === false) return null

      return (
        <Badge key={key}>
          <b>Minhas questões:</b> {MyQuestionsLabels[key]}{' '}
          <button className="remove" onClick={props.onMyQuestionsRemove(key)}>
            <IoMdClose className="icon" size={24} />
          </button>
        </Badge>
      )
    })

    return badges
  }

  const renderTextInputBadge = () =>
    props.textInput && (
      <Badge key="text-input-badge">
        <b>Pesquisa:</b> {limit(props.textInput)}{' '}
        <button className="remove" onClick={props.onTextInputRemove}>
          <IoMdClose className="icon" size={24} />
        </button>
      </Badge>
    )

  return (
    <SelectedFiltersContainer>
      <p className="title">
        Filtros selecionados:{' '}
        {totalFilters === 0 && <span className="empty-text">Os filtros aparecerão aqui.</span>}
      </p>
      {totalFilters > 0 && (
        <div className="badges">
          {renderTextInputBadge()}
          {renderSelectBadges()}
          {renderMyQuestionsBadges()}
          {renderCheckboxBadges()}
        </div>
      )}
    </SelectedFiltersContainer>
  )
}

const limit = (str: string) => {
  const SIZE = 30

  if (str.length > SIZE) {
    return str.substring(0, SIZE) + '...'
  }

  return str
}

export default SelectedFilters
